module.exports = "select{\r\n    min-width: 200px;\r\n}"